<script setup lang="ts">
import type { ButtonProps } from '@nuxt/ui'

const { t } = useI18n()

const error = useError()

const clear = {
  label: t('back_home'),
  color: 'neutral',
  variant: 'solid',
  size: 'lg'
}
</script>

<template>
  <UError
    :error="error"
    :clear="clear as ButtonProps"
  />
</template>
